import { type Client } from 'graphql-ws';
import { type SocketListeners } from './types.ts';

export function getSocketListeners(subscriptionsClient: Client): SocketListeners {
    return {
        connected: cb => subscriptionsClient.on('connected', cb),
        error: cb => subscriptionsClient.on('error', cb),
    };
}
